import { render, staticRenderFns } from "./AddApp.vue?vue&type=template&id=05312161&scoped=true"
import script from "./AddApp.vue?vue&type=script&lang=js"
export * from "./AddApp.vue?vue&type=script&lang=js"
import style0 from "./AddApp.vue?vue&type=style&index=0&id=05312161&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05312161",
  null
  
)

export default component.exports